import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import { memo } from 'react';
import { useAnchor, usePartial } from 'shared/hooks/utils';
import { EventFilters, } from 'console/device/device-event';
import { Button, Popover, Typography } from '@mui/material';
import { FilterList } from '@mui/icons-material';
import { FilterTree } from 'console/tabs/events/components/filter-tree';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { selectMapDashboardEnabled } from 'pages/dashboard.map/model/selectors';
import { isSmallUI } from 'shared/app/lib/choose-ui-type';
import { selectSelectedDevice } from 'entities/device/lib';
const emptyCaps = [];
function capsChecker(capabilities, item) {
    if (item.capsPred == null) {
        return true;
    }
    return item.capsPred(capabilities);
}
function filterEventGroupFromNetwork(show_network_events, gr) {
    return !(gr.id == 'network' && !show_network_events && gr.require_staff);
}
function filteredCount(event_filter_groups, event_filter) {
    let activeCount = 0;
    let totalCount = 0;
    event_filter_groups.forEach((group) => {
        activeCount += group.children.reduce((acc, el) => (event_filter[el.id] != false ? acc + 1 : acc), 0);
        totalCount += group.children.length;
    });
    return { activeCount, totalCount };
}
const anchorPopover = {
    vertical: 'bottom',
    horizontal: 'center',
};
const emptyFilter = {};
export const FilterButton = memo(function FilterButton() {
    const [anchor, open, close] = useAnchor();
    const event_filters = useAppSelector((state) => state.ui_settings.event_filter ?? emptyFilter);
    const capabilities = useAppSelector((state) => selectSelectedDevice(state)?.capabilities ?? emptyCaps);
    const show_network_events = useAppSelector((state) => !!state?.account.show_network_events);
    const show_geozones = useAppSelector(selectMapDashboardEnabled);
    const _capsChecker = usePartial(capsChecker, capabilities);
    const network_filter = usePartial(filterEventGroupFromNetwork, show_network_events);
    //отфильтровали группы фильтров по capability
    //отфильтровали группы фильтров по связи
    //отфильтровали детей группы по capability
    const filteredGroups = EventFilters.filter(_capsChecker)
        .filter(network_filter)
        .filter((ef) => (ef.id === 'geozones' ? show_geozones : true))
        .map((gr) => ({
        ...gr,
        children: gr.children.filter(_capsChecker),
    }));
    const { activeCount, totalCount } = filteredCount(filteredGroups, event_filters);
    return (_jsxs(_Fragment, { children: [_jsx(Button, { size: "small", startIcon: _jsx(FilterList, {}), onClick: open, sx: {
                    color: 'text.primary',
                    marginBottom: 1,
                    '@media (max-width: 365px)': {
                        marginRight: -2,
                    },
                }, children: _jsxs(Typography, { variant: "inherit", sx: {
                        fontWeight: 'bold',
                        '@media (max-width: 525px)': {
                            fontSize: '11.2px',
                        },
                        '@media (max-width: 395px)': {
                            marginLeft: -1,
                        },
                    }, children: [isSmallUI() ? 'фильтр' : 'фильтр событий ', activeCount !== totalCount
                            ? ' (' + activeCount + '/' + totalCount + ')'
                            : null] }) }), _jsx(Popover, { open: Boolean(anchor), anchorEl: anchor, onClose: close, anchorOrigin: anchorPopover, sx: {
                    maxHeight: '80%',
                }, children: _jsx(FilterTree, { event_filter: event_filters, event_filter_groups: filteredGroups }) })] }));
});
